module.exports = __webpack_public_path__ + "static/RiskFree-24d7427b5f5780f761931a1b06b34ee7.png";